import { brandInfo } from '@/mocks/homeData';
import { config } from '@/config';
import { motion } from 'motion/react';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const hasSocials = config.social.facebookUrl || config.social.instagramUrl || config.social.whatsappNumber;

  const quickLinks = [
    { label: 'Home', href: '#home' },
    { label: 'About', href: '#about' },
    { label: 'Products', href: '#products' },
    { label: 'Brands', href: '#brands' },
    { label: 'Services', href: '/services-repairs' },
    { label: 'Book Service', href: '/book-service' },
    { label: 'Repairs', href: '/services-repairs' },
    { label: 'Contact', href: '#contact' },
  ];

  const serviceLinks = [
    'Mobile Sales & Service',
    'Home & Kitchen Appliances',
    'Smart TV & LCD TV',
    'DTH Sales & Recharges',
    'Money Transfer',
    'Accessories & Gadgets',
    'EMI Plans',
  ];

  return (
    <footer className="bg-foreground-950 text-background-300">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <img
                src="https://static.readdy.ai/image/d59ba4ba4e5f160e4781d8b81f851394/f5735cd9a713fc9d715878d69c8293bc.png"
                alt="Ashok Telecom Logo"
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="text-background-400 text-sm leading-relaxed mb-4">
              Your trusted partner in Tumkur since {config.business.establishedYear}. Mobiles, Home &amp; Kitchen Appliances, DTH, Money Transfer, and more — connecting lifestyles &amp; households.
            </p>
            <a
              href={`tel:${config.business.phone}`}
              className="inline-flex items-center gap-2 text-primary-400 hover:text-primary-300 text-sm font-medium transition-colors cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-xs"></i>
              </span>
              {brandInfo.phone}
            </a>

            {hasSocials && (
              <div className="flex items-center gap-3 mt-5">
                {config.social.facebookUrl && (
                  <a
                    href={config.social.facebookUrl}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    aria-label="Follow us on Facebook"
                    className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700/40 text-background-400 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer"
                  >
                    <i className="ri-facebook-fill text-sm"></i>
                  </a>
                )}
                {config.social.instagramUrl && (
                  <a
                    href={config.social.instagramUrl}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    aria-label="Follow us on Instagram"
                    className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700/40 text-background-400 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer"
                  >
                    <i className="ri-instagram-line text-sm"></i>
                  </a>
                )}
                {config.social.whatsappNumber && (
                  <a
                    href={`https://wa.me/${config.social.whatsappNumber.replace(/[^0-9]/g, '')}`}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    aria-label="Chat with us on WhatsApp"
                    className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700/40 text-background-400 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-sm"></i>
                  </a>
                )}
              </div>
            )}
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-base mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <motion.a
                    href={link.href}
                    whileHover={{ x: 4 }}
                    className="inline-block text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </motion.a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-base mb-4">
              Services
            </h4>
            <ul className="space-y-2.5">
              {serviceLinks.map((service) => (
                <li key={service}>
                  <span className="text-background-400 text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-base mb-4">
              Visit Us
            </h4>
            <p className="text-background-400 text-sm leading-relaxed mb-3">
              {brandInfo.address}
            </p>
            <p className="text-background-500 text-xs">
              {brandInfo.hours}
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 md:pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs md:text-sm text-center sm:text-left">
            &copy; {currentYear} {config.business.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            <span className="text-background-500 text-xs">
              Powered by:{' '}
              <a
                href="https://digicube.net.in"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="hover:text-background-300 transition-colors cursor-pointer"
              >
                Digicube Solutions
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}